/* eslint-disable import/no-unresolved */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Provider } from 'jotai';
import { filterSelector } from '@store/common/selectors';
import { useParams, useHistory } from 'react-router-dom';
import { ErrorBoundary, PageTitle } from '@components/common';
import { selector as commonSelector } from '@store/common';
import RetryContext from '@src/contexts/retryContext';
import DashboardTabs from '@components/common/Dashboard/DashboardTabs';
import EmpFunnelPage from '@components/common/EmpWidget/EmpFunnelPage';
import { buildDashboardStore } from '@src/atoms/utils';
import { APP_FUNNEL_KEY } from '@utils/constants';
import sankeyStore from '@src/globalStore/sankeyStore';
import { get } from 'lodash';
import { updateWidgetProps } from '@components/common/EmpWidget/EMPWidgetContainer';
import { useGoToUserTimeline } from '@src/pages/Sankey/index';
import ReleaseVersion from '@components/common/ReleaseVersion';

const defaultStore = buildDashboardStore();

function Funnel(props) {
  // const [showModal, setShowModal] = React.useState(false);
  const { match, store = defaultStore } = props;
  const globalFilter = useSelector(filterSelector);
  const { id: eventName }: any = useParams();
  const { interval } = useSelector(commonSelector);
  const id = get(match, 'params.id', APP_FUNNEL_KEY); // default home page is trends
  const history = useHistory();
  // @ts-expect-error history.location.state
  const from = history.location.state?.from;
  const initFunnelPayload = sankeyStore((state) => state.initFunnelPayload);
  const onGoToUserTimeline = useGoToUserTimeline();

  return (
    <Provider store={store}>
      <>
        <RetryContext.Provider value={{ interval }}>
          <ErrorBoundary>
            <div style={{ height: '100%' }}>
              <DashboardTabs id={id} />
              <PageTitle text="Funnel" />
              <ReleaseVersion type={'Beta'} style={{ insetInlineEnd: 0, top: 0 }} />
              <EmpFunnelPage
                interval={interval}
                globalFilter={globalFilter}
                eventName={eventName}
                onModalClose={() => {
                  // go to previous page
                  history.goBack();
                  updateWidgetProps({
                    widgetName: '',
                    open: false,
                  });
                }}
                initFunnelPayload={{ ...initFunnelPayload, from }}
                onGoToUserTimeline={onGoToUserTimeline}
              />
              {/* <Footer /> */}
            </div>
          </ErrorBoundary>
        </RetryContext.Provider>
      </>
    </Provider>
  );
}

export default Funnel;
